import styled from 'styled-components';
import { select, withQuery } from '@panel/commons/core/themev2';
import arrowDown from '@panel/commons/assets/icons/selectArrow.svg';
import { getColor } from '@panel/commons/core/themev3';

const SectionContainer = styled.div`
  width: 100%;
  padding-left: 40px;
  padding-bottom: 40px;
  margin: 0px;
  ${withQuery.lg.down()} {
    padding-left: 20px;
  }
  ${withQuery.md.down()} {
    padding: 0px;
    padding-bottom: 20px;
    margin: 0px 16px;
  }
`;

const BottomSectionBody = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const Title = styled.h1`
  font-family: 'Hind';
  font-size: 2rem;
  font-style: normal;
  font-weight: 600;
  line-height: 26px;
`;

const SelectContainer = styled.div`
  margin-right: 64px;
  margin-top: 32px;
  > label {
    font-family: 'Hind';
    font-size: 1.4rem;
    font-style: normal;
  }
  > select {
    display: block;
    height: 48px;
    width: 289px;
    padding: 0 15px;
    border: 1px solid ${select('middleGray')};
    border-radius: 8px;
    margin: 10px 0;
    background-color: ${select('white')};
    appearance: none;
    background-image: ${`url(${arrowDown})`};
    background-repeat: no-repeat;
    background-position: right;
    background-origin: content-box;
    color: ${props => !props.hasValue && select('midDarkGray')};
    > option {
      color: ${select('black')};
    }
    &:hover,
    &:focus {
      border: 1px solid ${getColor('primary')};
      cursor: pointer;
    }
    ${withQuery.xs.down()} {
      width: 328px;
    }
  }
`;

const InputContainer = styled.div`
  margin-right: 64px;
  margin-top: 32px;
  > label {
    font-family: 'Hind';
    font-size: 1.4rem;
    font-style: normal;
  }
  > input {
    height: 48px;
    width: 289px;
    border-radius: 8px;
    border: 1px solid ${select('middleGray')};
    display: block;
    padding: 13px 12px;
    :placeholder-shown {
      color: ${select('midDarkGray')};
    }
    :focus {
      border: 1px solid ${getColor('primary')};
      cursor: pointer;
    }
    ${withQuery.xs.down()} {
      width: 328px;
    }
  }
`;

const ErrorMessage = styled.span`
  color: ${select('negative')};
  display: inherit;
  padding: 7px 0px 0px 15px;
  font-size: 12px;
`;

export { SectionContainer, BottomSectionBody, Title, SelectContainer, InputContainer, ErrorMessage };
